<template>
  <router-view />
</template>

<script>
export default {
  name: "ServicePartnersBase",
};
</script>
